// Keep in sync with the backend's MAX_UPLOAD_SIZE_MB (src/config/upload-limits.ts)
// and nginx's client_max_body_size — rejecting oversized photos here avoids
// starting an upload that the server (or proxy) would otherwise drop.
export const MAX_PHOTO_BYTES = 20 * 1024 * 1024;

export function isPhotoTooLarge(sizeBytes: number): boolean {
  return sizeBytes > MAX_PHOTO_BYTES;
}
